import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'What makes your tailoring different from other tailors?',
    a: 'We take 30+ precision measurements compared to the 10–15 that most tailors use. Every pattern is drafted specifically for your body from scratch — no templates, no standardized sizes. We also carry 5,000+ premium fabrics and have 55+ years of hands-on bespoke experience. The result is a garment you simply cannot get anywhere else.',
  },
  {
    q: 'Do you work with first-time clients?',
    a: 'Absolutely. First-time clients are warmly welcomed. Many of our best long-term relationships began with a client who had never owned a custom garment before. We guide you through every decision — from silhouette and fabric selection to finishing details — so you feel completely confident throughout the process.',
  },
  {
    q: 'Can you come to my home or office?',
    a: 'Yes. We offer house and office call appointments throughout Massachusetts and New England. Our tailor will bring fabric swatches, take your measurements, and provide the full consultation experience — right at your location. It is a premium service that fits perfectly into your busy schedule.',
  },
  {
    q: 'Do you make wedding suits?',
    a: 'Yes — wedding and formalwear is one of our most beloved services. We create fully bespoke wedding suits, tuxedos, and formalwear for grooms and entire wedding parties. We also coordinate looks across groomsmen for a cohesive, polished presentation on your most important day.',
  },
];

const AboutFAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      {/* FAQ */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-3">
              Common Questions
            </p>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-500 text-lg">
              Everything you want to know before your first visit.
            </p>
          </div>

          <div
            itemScope
            itemType="https://schema.org/FAQPage"
            className="space-y-4"
          >
            {faqs.map((faq, i) => (
              <div
                key={i}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-100 transition-colors"
                >
                  <span itemProp="name" className="font-semibold text-gray-900 pr-4">
                    {faq.q}
                  </span>
                  <i
                    className={`text-[#C4A962] text-xl flex-shrink-0 transition-transform ${
                      openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                {openIndex === i && (
                  <div
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                    className="px-6 pb-5"
                  >
                    <p itemProp="text" className="text-gray-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Come Experience the Difference
              </h2>
              <p className="text-gray-300 text-xl leading-relaxed mb-8">
                Whether you are new to bespoke tailoring or a seasoned client, we would love
                to meet you. Visit our Wellesley showroom or let us come to you.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/contact"
                  className="bg-[#C4A962] text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-[#B39952] transition-all transform hover:scale-105 whitespace-nowrap text-center"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Book a Consultation
                </Link>
                <a
                  href="tel:781-237-3166"
                  className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap text-center"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Call 781-237-3166
                </a>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden h-72 lg:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/d41802027037efe2afa311567dbcc4a9.jpg"
                alt="Consultation at Custom Clothiers"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutFAQSection;
